var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],staticClass:"gl-font-weight-bold",attrs:{"size":"sm","title":_vm.__('Health status'),"variant":_vm.statusClass}},[_vm._v("\n  "+_vm._s(_vm.statusText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }